const appConfig = {
  "name": "covid-access-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://mitprod.okta.com/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "69am70cg2q3bu0j719ei0r7m9i",
    "redirectUris": [
      "https://mitaccess-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://mitaccess-mr.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "email",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "user/admin.covid19-access",
      "user/admin.covid19-medical",
      "user/admin.search",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "69am70cg2q3bu0j719ei0r7m9i",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "covid19/access",
        "covid19/impersonate",
        "covid19/user",
        "digital-id/search",
        "digital-id/user",
        "openid",
        "profile",
        "user/admin.covid19-access",
        "user/admin.covid19-medical",
        "user/admin.search",
        "user/all"
      ],
      "redirectUris": [
        "https://mitaccess-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://mitaccess-mr.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;